module.exports = __webpack_public_path__ + "img/mi-speciale-onderzoeken.165c5026.svg";